import styled, { Spacing, Utils, Color } from '@nfinite/react-hubstairs/styled'

export const Container = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`

export const Label = styled('label')`
  white-space: nowrap;
  ${Spacing.generateMargin({ right: 'xs' })}
  ${Utils.generateEllipsisMultiline('m', 2)}
  ${({ htmlFor, isClickable }) => (htmlFor || isClickable ? 'cursor: pointer;' : '')}
`

export const RightLabel = styled('label')`
  white-space: nowrap;
  ${Spacing.generateMargin({ left: 'xs' })}
  ${Utils.generateEllipsisMultiline('m', 2)}
  ${({ htmlFor }) => htmlFor && `cursor: pointer;`}
`

export const SwitchWrapper = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 50px;
`
export const NullStateSwitch = styled('div')`
  width: 50px;
  height: 30px;
  background: ${Color.get('primary')};
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &::after {
    content: '';
    height: 8px;
    width: 20px;
    border-radius: 4px;
    background: white;
  }
`
